import { entries } from "lodash-es";

type TypenameKey = "__typename";

type PluckTypename<Operation> =
    Operation extends Partial<Record<TypenameKey, infer Typename>> ? Extract<Typename, string> : never;

// For now, a flag is just a boolean.
type Flag = boolean;

type RequiredTypenameForOperation<Operation> =
    Operation extends Array<infer V>
        ? PluckTypename<V> | RequiredTypenameForOperation<V>
        : Operation extends Record<string, infer V>
          ? RequiredTypenameForOperation<V>
          : never;
type OptionalTypenameForOperation<Operation> =
    Operation extends Array<infer V>
        ? OptionalTypenameForOperation<V>
        : Operation extends Record<string, infer V>
          ? PluckTypename<Operation> | OptionalTypenameForOperation<V>
          : never;

export type NonInferredTypenameForOperation = Record<string, Flag>; // TODO: Restrict this to names of actual types.
export type StrictFlagsByTypename<Operation> = Record<RequiredTypenameForOperation<Operation>, Flag> &
    Partial<Record<OptionalTypenameForOperation<Operation>, Flag>>;
export type FlagsByTypename<Operation> = StrictFlagsByTypename<Operation> & NonInferredTypenameForOperation;

/**
 * A type-safe way to enforce that we specify additional array typenames for query invalidation.
 * @see https://formidable.com/open-source/urql/docs/basics/document-caching/#document-cache-gotchas.
 *
 * @param flags A map of possible array typenames to a boolean. If true, we return it in the list below.
 * @returns A list of additional typenames to invalidate.
 */
export function getAdditionalTypenamesForOperation<Operation>(flags: FlagsByTypename<Operation>): string[] {
    return entries(flags)
        .filter(([, flag]) => flag)
        .map(([typename]) => typename);
}
